const reasons = [
  {
    icon: "ri-award-line",
    title: "Expert Craftsmanship",
    desc: "Our skilled installation teams bring over 12 years of specialist experience in windows and doors, ensuring every project is completed to the highest standard.",
  },
  {
    icon: "ri-shield-check-line",
    title: "10-Year Guarantee",
    desc: "We stand behind our work with a comprehensive 10-year guarantee on all products and installations, giving you complete peace of mind.",
  },
  {
    icon: "ri-ruler-2-line",
    title: "Made to Measure",
    desc: "Every product is precisely measured and manufactured to your exact specifications. No off-the-shelf solutions — just perfect-fit results every time.",
  },
  {
    icon: "ri-money-pound-circle-line",
    title: "Competitive Pricing",
    desc: "Premium quality doesn't have to mean premium prices. We offer transparent, competitive quotes with no hidden extras or unwanted surprises.",
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Dedicated Support",
    desc: "From first enquiry to aftercare, our friendly team is always on hand to answer questions, provide advice, and ensure your complete satisfaction.",
  },
  {
    icon: "ri-recycle-line",
    title: "Sustainable Products",
    desc: "Our windows and doors are manufactured using sustainable materials and processes, helping to reduce your home's carbon footprint alongside energy bills.",
  },
];

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Image */}
          <div className="relative">
            <div className="w-full h-[500px] rounded-lg overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/80dd2f623e6a0e85170193aca24e360e.jpg"
                alt="Expert installation team"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Badge */}
            <div className="absolute -bottom-6 -right-6 bg-amber-600 text-white rounded-lg p-6 w-40 text-center">
              <p className="text-3xl font-bold" style={{ fontFamily: "'Cormorant Garamond', serif" }}>12+</p>
              <p className="text-xs mt-1 leading-tight" style={{ fontFamily: "'Raleway', sans-serif" }}>Years of Excellence</p>
            </div>
          </div>

          {/* Right - Content */}
          <div>
            <span
              className="text-amber-600 text-xs font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Raleway', sans-serif" }}
            >
              Why Choose Us
            </span>
            <h2
              className="text-4xl lg:text-5xl font-bold text-zinc-900 mt-3 mb-6"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Quality You Can Trust, Service You Deserve
            </h2>
            <p className="text-zinc-500 text-base leading-relaxed mb-10" style={{ fontFamily: "'Raleway', sans-serif" }}>
              At Ensure Windows, we believe every home deserves beautiful, high-performing windows and doors. Our commitment to quality craftsmanship and outstanding customer service sets us apart in Surrey and South London.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {reasons.map((r) => (
                <div key={r.title} className="flex items-start gap-4">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-amber-50 rounded-md">
                    <i className={`${r.icon} text-amber-600 text-lg`}></i>
                  </div>
                  <div>
                    <h4
                      className="text-base font-bold text-zinc-800 mb-1"
                      style={{ fontFamily: "'Raleway', sans-serif" }}
                    >
                      {r.title}
                    </h4>
                    <p className="text-zinc-500 text-sm leading-relaxed" style={{ fontFamily: "'Raleway', sans-serif" }}>
                      {r.desc}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
